import React, { useMemo } from "react";
import classNames from "classnames";
import Mask from "../mask";
import { SuccessIcon, ErrorIcon, InfoIcon } from "@t8891/icon";
var clsPrefix = "tc-toast";
export var InternalToast = function InternalToast(props) {
  var _props$maskClickable = props.maskClickable,
    maskClickable = _props$maskClickable === void 0 ? true : _props$maskClickable,
    content = props.content,
    icon = props.icon,
    position = props.position,
    getContainer = props.getContainer,
    afterClose = props.afterClose,
    maskClassName = props.maskClassName;
  var iconElement = useMemo(function () {
    if (icon === null || icon === undefined) return null;
    switch (icon) {
      case "success":
        return /*#__PURE__*/React.createElement(SuccessIcon, {
          size: 60,
          fill: '#fff'
        });
      case "fail":
        return /*#__PURE__*/React.createElement(ErrorIcon, {
          size: 60,
          fill: '#fff'
        });
      case "warning":
        return /*#__PURE__*/React.createElement(InfoIcon, {
          size: 60,
          fill: '#fff'
        });
      default:
        return icon;
    }
  }, [icon]);
  var top = useMemo(function () {
    switch (position) {
      case "top":
        return "20%";
      case "bottom":
        return "80%";
      default:
        return "50%";
    }
  }, [position]);
  return /*#__PURE__*/React.createElement(Mask, {
    visible: props.visible || false,
    destroyOnClose: true,
    disableBodyScroll: !maskClickable,
    getContainer: getContainer,
    afterClose: afterClose,
    style: {
      background: "rgba(0, 0, 0, 0)",
      pointerEvents: maskClickable ? "none" : "auto"
    },
    className: classNames("".concat(clsPrefix, "-mask"), maskClassName)
  }, /*#__PURE__*/React.createElement("div", {
    className: classNames("".concat(clsPrefix, "-wrap"))
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      top: top
    },
    className: classNames("".concat(clsPrefix, "-main"), icon ? "".concat(clsPrefix, "-main-icon") : "".concat(clsPrefix, "-main-text"))
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(clsPrefix, "-icon")
  }, iconElement), content)));
};
InternalToast.defaultProps = {
  maskClickable: true,
  stopPropagation: ["click"]
};